<template>
    <div>
        <b-card>
            <div slot="header">Trängselskatt periodvis
                <div class="card-header-actions">
                    <b-spinner v-if="loading" class="mr-1" type="border" small />
                </div>
            </div>
            <UsersDropdown employeeOnly=true :selectedUserId="selectedUserId" @onUserSelected="userSelected" v-if="loginState.isAuditor"/>

            <table class="table table-striped table-hover mt-2" v-if="congestions.length > 0">
                <thead>
                <tr >
                    <th class="col-7">Period</th>
                    <th class="col-2">Attesterad</th>
                    <th class="col-1"></th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="congestion in congestions"
                    v-bind:class="{ 'bg-danger': !congestion.isValid }"
                    :key="congestion.id"
                    v-on:click="edit(congestion)"
                    style="cursor:pointer">
                    <td class="col-10">{{congestion.passages[0].date | moment("YYYY-MM-DD")}} - {{congestion.passages.slice(-1)[0].date | moment("YYYY-MM-DD")}}</td>
                    <td class="col-2 text-center"><i class="cui-check icons font-xl d-block" style="color:green;" v-if="congestion.isAttested"></i></td>
                    <td class="col-1 text-center"><i class="fa fa-trash-o fa-lg" v-if="!congestion.isAttested" v-on:click.stop="deleteCongestion(congestion)"></i></td>
                </tr>
                </tbody>
            </table>
            <p class="mt-2" v-if="congestions.length == 0 && selectedUserId">No results exists for the user</p>
        </b-card>
    </div>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { congestionsService, expensesService } from "../../shared/services";
import UsersDropdown from '../components/UsersDropdown'

export default {
  components: {
      UsersDropdown
  },

  data() {
    return {
      selectedUserId: null
    }
  },
  methods: {
    userSelected(user) {
      this.selectedUserId = user.isEmployee ? user.id : null;
      console.log("Collecting congestions for " + user.id)
      this.loading = true;
      congestionsService.getAll(user.id)
      .then(p => {
          this.loading = false;
          this.congestions = p;
      })
      .catch(() => {
          this.ShowToast("Fel", "Ett okänt fel uppstod då trängselskatt skulle hämtas", "danger")
          this.loading = false;
      });
    },
    edit(congestion) {
      this.$router.push({ path: `/expenses/congestiontax/${congestion.id}` });
    },
    async deleteCongestion(congestion) {
        var result = await  this.$bvModal.msgBoxConfirm(`Är du säker på att du vill radera trängselskatten för ${ this.$moment(congestion.passages[0].date).format("YYYY-MM-DD")} - ${this.$moment(congestion.passages.slice(-1)[0].date).format("YYYY-MM-DD")}?`);
        if(!result) return;

        try {
          await congestionsService.deleteCongestion(congestion);
        } catch {
          this.ShowToast("Fel", "Ett okänt fel uppstod då trängselskatt skulle raderas", "danger")
        }
        finally {
          this.congestions = this.congestions.filter(p => p.id != congestion.id);
        }
    }
  },
  mounted() {
    this.selectedUserId = this.$route.query.userId ? this.$route.query.userId : globalStore.loginState.user.id;
    this.userSelected(globalStore.loginState.user);
    
  },
  data () {
    return {
      loading: false,
      selectedUserId: 0,
      congestions: []
    }
  },
}
</script>

<style>

</style>
